// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__WkiDE","balanceDisclaimer":"posDashboard_balanceDisclaimer__1BbWA"};